import React from 'react';
import styles from './Hero.module.scss';

interface IHeroProps {
    title: string;
    description: string;
    children?: React.ReactNode;
    customClass?: string;
}

export default function Hero({ title, description, children, customClass }: IHeroProps) {
    return (
        <section className={`${styles.hero_card} ${customClass}`}>
            <h3>{title}</h3>
            <p>{description}</p>

            {children}
        </section>
    );
}
